document.addEventListener('submit', async (e) => {
  const f = e.target.closest('.js-add'); if (!f) return;
  e.preventDefault();
  const btn = f.querySelector('[type=submit]'); btn && (btn.disabled = true);
  try {
    const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
    if (!r.ok) throw new Error();
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('.js-cart-count').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    toast('Tillagd i varukorgen');
  } catch { toast('Kunde inte lägga till'); }
  btn && (btn.disabled = false);
});
function toast(msg){ const t=document.createElement('div'); t.className='toast'; t.textContent=msg; document.body.appendChild(t); setTimeout(()=>t.remove(),2200); }
